module.exports = __webpack_public_path__ + "static/img/appearance.90770cf8.png";